import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createItem, updateItem, deleteItem } from '../services/smr-admin';
import type { ItemPayload } from '../services/smr-admin';
import { itemKeys } from './useItemsQuery';

export const useItemMutations = () => {
    const queryClient = useQueryClient();
    const invalidate = () => queryClient.invalidateQueries({ queryKey: itemKeys.lists() });

    return {
        createMutation: useMutation({ mutationFn: createItem, onSuccess: invalidate }),
        updateMutation: useMutation({
            mutationFn: ({ id, payload }: { id: string; payload: ItemPayload }) => updateItem(id, payload),
            onSuccess: invalidate,
        }),
        deleteMutation: useMutation({ mutationFn: deleteItem, onSuccess: invalidate }),
    };
};
